// Домашний майонез 180 гр - 4812
// Домашний соус Песто 200 гр - 4813
// Домашний соус Цезарь 200 гр - 4814
// Домашний соус Блючиз 200 гр - 4815
// Домашняя аджика с перцем 200 гр - 5036
// Луковый джем с сахаром 215 гр - 5037
// Медовая горчица 200 гр - 5038
// Соленая карамель 250 гр - 5040

export const dishes = [
    '4812',
    '4813',
    '4814',
    '4815',
    '5036',
    '5037',
    '5038',
    '5040',
];
